import {Api,handleResponse,handleError} from '../../../../../../../../api';
//Action
const Actions = {
    SetDecision: 'inner/offer-decision-empty',
}


export const apiRequest = {
    setDecision
};

async function setDecision(parent,data) {
    const {onRefresh,setIsClosed,onClose} = parent.props;
    await new Api().call.post(Actions.SetDecision,data).then(handleResponse)
        .then(res => {
            parent.setState({
                loading:false,
                response:res
              });
              onRefresh();         
              onClose();
              setIsClosed();
            }).catch(error=>{
                if(error!=null && error!==undefined && error.response!==null && error.response!==undefined){
                    parent.setState({
                        response:error.response.data,
                        loading:false
                    });
                }
                else{
                    parent.setState({
                        response:{message:'Váratlan hiba történt',type:'error'},
                        loading:false
                    });
                }
                handleError(error);
            });
}